import { StyleSheet } from 'react-native';
import {
  buttonBackgroundHover,
  buttonPadding,
  buttonBorderRadius,
  buttonTextHover,
  disabledBackgroundColor,
  fontSizeMedium,
  minButtonWidth,
  white,
} from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    alignItems: 'center',
    padding: buttonPadding,
    borderRadius: buttonBorderRadius,
    minWidth: minButtonWidth,
  },
  gradient: {
    borderRadius: buttonBorderRadius,
    minWidth: minButtonWidth,
  },
  disabledStyle: {
    alignItems: 'center',
    backgroundColor: disabledBackgroundColor,
    padding: buttonPadding,
    borderRadius: buttonBorderRadius,
    minWidth: minButtonWidth,
    // cursor: 'not-allowed' // not allowed on mobile
  },
  hoverStyle: {
    alignItems: 'center',
    backgroundColor: buttonBackgroundHover,
    padding: buttonPadding,
    borderRadius: buttonBorderRadius,
    minWidth: minButtonWidth,
  },
  hoverTextStyle: {
    color: buttonTextHover,
    fontSize: fontSizeMedium,
  },
  text: {
    color: white,
    fontSize: fontSizeMedium,
  },
});
